import {AuthConfig} from 'angular-oauth2-oidc';
import {environment} from '../../environments/environment';

export const authConfig: AuthConfig = {
    issuer: environment.SsoUrl,
    clientId: environment.SsoClientId,
    dummyClientSecret: environment.SsoDummyClientSecret,
    scope: environment.SsoScope,

    responseType: 'code',
    redirectUri: window.location.origin + '/index.html',
    silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
    useSilentRefresh: false,
    sessionChecksEnabled: false,
    showDebugInformation: false,
    clearHashAfterLogin: true,
    requestAccessToken: true,
    disablePKCE: false,
    nonceStateSeparator: 'semicolon',
};
